// Turns a camelCase / PascalCase enum value into spaced words, e.g. `highNeed` → `High Need`.
// Used as a display fallback wherever a hand-kept label map does not cover a value.
export const humanizeEnumValue = (value: string) =>
  value
    .replace(/([a-z0-9])([A-Z])/g, '$1 $2')
    .replace(/\s+/g, ' ')
    .trim();
